import React from 'react'
import PopupModal from '../../../../components/popup-bottom-modal'
import { CHARGE_CDN } from '../../../../utils/constants'
import './index.less'
import { trackGdp } from '../../../../utils/gio-report'
import { UserTypeEnum } from '../../../../api/pile'
interface SharingOpenSuccessModalPropsRule {
    visible: boolean
    setVisible: (status: boolean) => void
    userInfo?: any
    onShare: () => void
}

const SharingOpenSuccessModal = (props: SharingOpenSuccessModalPropsRule) => {
    const { visible, setVisible, userInfo } = props
    return (
        visible
            ?
            <PopupModal
                visible={visible}
                title='恭喜成功开通共享家充'
                onClose={() => { setVisible(false) }}
            >
                <div className='open-success-container'>
                    <div className='tip'>开启你的共享之旅</div>
                    <img src={`${CHARGE_CDN}/sharing/pile_owner_first_activate_v2.png`} alt="" className='success-img' />
                    <div className='tip1'>提示:</div>
                    <div className='tip2'>1. 其他用户首次使用需经你同意，记得及时处理</div>
                    <div className='btn-container' onClick={
                        () => {
                            trackGdp('P20075', 'B003', {
                                userId: userInfo?.uid,
                                userType: UserTypeEnum[userInfo?.type]
                            })
                            props.onShare && props.onShare()
                            setVisible(false)
                        }
                    }>
                        <div className='invite-btn'>邀请好友来充电</div>
                    </div>
                </div>
            </PopupModal>
            : null
    )
}

export default SharingOpenSuccessModal